<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="LeavePoliciesForm" (ngSubmit)="Validate(LeavePoliciesForm)" #LeavePoliciesForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Leave Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="LeaveRuleName" class="form-label text-label-dark">Policy Name :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="LeaveRuleName" name="LeaveRuleName" [(ngModel)]="LeaveRuleDetail.LeaveRuleName"
                                #LeaveRuleName="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.LeaveRuleDetail.ESS_LeaveRuleID == 0) || (this.LeaveRuleDetail.ESS_LeaveRuleID > 0 && common.ToLowerCase(LeaveRuleDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="LeaveRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()" [disabled]="LeaveRuleDetail.ESS_LeaveRuleID > 0"
                                        required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.LeaveRuleDetail.ESS_LeaveRuleID == 0) || (this.LeaveRuleDetail.ESS_LeaveRuleID > 0 && common.ToLowerCase(LeaveRuleDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="LeaveRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()" [disabled]="LeaveRuleDetail.ESS_LeaveRuleID > 0"
                                        required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto align-self-center" style="margin-right: 6px;">
                            <label for="LeaveRuleCode" class="form-label text-label-dark">Policy Code :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Code"
                                id="LeaveRuleCode" name="LeaveRuleCode" [(ngModel)]="LeaveRuleDetail.LeaveRuleCode"
                                #LeaveRuleCode="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter rule code!
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center" style="width: 7rem;">
                            <label for="Leave" class="form-label text-label-dark">Leave: </label>
                        </div>
                        <div class="col-md-5">
                            <select class="form-select text-label-light" aria-label="Leave" placeholder="Leave"
                                title="Leave" name="Leave" [(ngModel)]="LeaveRuleDetail.LeaveMasterId"
                                (change)="onSelectChange()" #Leave="ngModel" required>
                                <option disabled [value]=null>--Select Leave--</option>
                                <option *ngFor="let LeaveType of LeaveTypes" [value]=LeaveType.LeaveMasterID>
                                    {{LeaveType.LeaveName}}</option>
                            </select>
                            <div class="invalid-feedback">
                                Please select leave!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3" style="color: rgb(194, 189, 189);">
                        <div class="col-md-auto align-self-center">
                            <label for="LeaveType" class="form-label text-label-dark">Leave Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Paid' name="LeaveType"
                                        [(ngModel)]="LeaveRuleDetail.LeaveType" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    Paid
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Unpaid' name="LeaveType"
                                        [(ngModel)]="LeaveRuleDetail.LeaveType" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    Unpaid
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3" style="color: rgb(194, 189, 189);">
                        <div class="col-md-auto align-self-center">
                            <label class="form-check-label text-label-dark" for="IsGender">
                                Gender :
                            </label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='All' name="Gender"
                                        [(ngModel)]="LeaveRuleDetail.Gender" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    All
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Male' name="Gender"
                                        [(ngModel)]="LeaveRuleDetail.Gender" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    Male
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Female' name="Gender"
                                        [(ngModel)]="LeaveRuleDetail.Gender" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    Female
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Other' name="Gender"
                                        [(ngModel)]="LeaveRuleDetail.Gender" [ngModelOptions]="{standalone: true}"
                                        disabled>
                                    Other
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3" style="color: rgb(194, 189, 189);">
                        <div class="col-md-auto align-self-center">
                            <label class="form-check-label text-label-dark" for="IsMaritialStatus">
                                Marital Status :
                            </label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='All' name="MaritialStatus"
                                        [(ngModel)]="LeaveRuleDetail.MaritialStatus"
                                        [ngModelOptions]="{standalone: true}" disabled>
                                    All
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Married' name="MaritialStatus"
                                        [(ngModel)]="LeaveRuleDetail.MaritialStatus"
                                        [ngModelOptions]="{standalone: true}" disabled>
                                    Married
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='Unmarried' name="MaritialStatus"
                                        [(ngModel)]="LeaveRuleDetail.MaritialStatus"
                                        [ngModelOptions]="{standalone: true}" disabled>
                                    Unmarried
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Minimum presence criteria :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.LeavePolicy.Minimumdaystobepresentforleaveeligibility"></i>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.MinimumDaysForLeaveEligibility) > 365}"
                                    placeholder="Ex. 01" id="MinimumDaysForLeaveEligibility"
                                    name="MinimumDaysForLeaveEligibility"
                                    [(ngModel)]="LeaveRuleDetail.MinimumDaysForLeaveEligibility"
                                    #MinimumDaysForLeaveEligibility="ngModel" required>
                                <span class="input-group-text" id="basic-MinimumDaysForLeaveEligibility">day</span>
                                <div class="invalid-feedback">
                                    Please enter maximum days 365!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <ng-select [items]="Leaveeligibility" [multiple]="true" bindLabel="LeaveeligibilityName"
                                bindValue="LeaveeligibilityID" placeholder="Leave eligibility" [closeOnSelect]="false"
                                [(ngModel)]="LeaveRuleDetail.LeaveeligibilityIDs" name="LeaveeligibilityIDs" required>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                        [ngModel]="item$.selected" [ngModelOptions]="{ standalone : true }" />
                                    {{item.LeaveeligibilityName}}
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value" *ngFor="let item of items.slice(0,3)">
                                        <span class="ng-value-label">{{item.LeaveeligibilityName}}</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 3">
                                        <span class="ng-value-label">{{items.length - 3}} more...</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select leave eligibility!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowRegulariationForPreviousMonth" class="form-label text-label-dark">Allow
                                leave for previous
                                month :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRegulariationForPreviousMonth"
                                        [(ngModel)]="LeaveRuleDetail.AllowLeaveForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="checkExtraleaveTypeDisableFild()">
                                    Yes
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.AllowleaveforpreviousmonthYES"></i>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRegulariationForPreviousMonth"
                                        [(ngModel)]="LeaveRuleDetail.AllowLeaveForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="checkExtraleaveTypeDisableFild()">
                                    No
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.AllowleaveforpreviousmonthNO"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Allow Request After Monthlock :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="LeaveRuleDetail.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="checkExtraleaveTypeDisableFild()">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="LeaveRuleDetail.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="checkExtraleaveTypeDisableFild()">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-0">
                        <div class="col-md-auto">
                            <label for="LeaveCalculated" class="form-label text-label-dark">Calculation Type
                                :</label>
                        </div>
                        <div class="col-md-auto">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='f' name="LeaveCalculated"
                                        [(ngModel)]="LeaveRuleDetail.LeaveCalculated"
                                        [ngModelOptions]="{standalone: true}">
                                    Fixed Value
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.LeavetobecalculatedonFixed"></i>

                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='p' name="LeaveCalculated"
                                        [(ngModel)]="LeaveRuleDetail.LeaveCalculated"
                                        [ngModelOptions]="{standalone: true}">
                                    Pro-rated
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.LeavetobecalculatedonProrated"></i>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <label for="ProRatedLeaveCalOn" class="form-label text-label-dark">Division Factor</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="Leave" placeholder="Base on"
                                title="ProRatedLeaveCalOn" name="ProRatedLeaveCalOn"
                                [(ngModel)]="LeaveRuleDetail.ProRatedLeaveCalOn" #ProRatedLeaveCalOn="ngModel" required
                                [disabled]="this.common.ToLowerCase(LeaveRuleDetail.LeaveCalculated) != 'p'">
                                <option disabled [value]=null>--Select--</option>
                                <option value='Total Month Days'>Total Month Days</option>
                                <option value='Total Working Days'>Total Working Days</option>
                                <option value='Fixed Days'>Fixed days</option>
                            </select>
                            <div class="invalid-feedback">
                                Please select leave to be calculated base on!
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.ProRatedFixedDays) > 365}"
                                    class="form-control text-label-light" placeholder="Ex. 01" id="ProRatedFixedDays"
                                    name="ProRatedFixedDays" [(ngModel)]="LeaveRuleDetail.ProRatedFixedDays"
                                    #ProRatedFixedDays="ngModel" required [disabled]="ProRatedFixedDaysDisable()">
                                <span class="input-group-text" id="basic-limit">day's </span>
                                <div class="invalid-feedback">
                                    Please enter day's!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="CreditBasedOn" class="form-label text-label-dark">Credit BasedOn:</label>
                        </div>
                        <div class="col-md-3" style="width:16.7rem">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='salary' name="CreditBasedOn"
                                        [(ngModel)]="LeaveRuleDetail.CreditBasedOn"
                                        [ngModelOptions]="{standalone: true}" (change)="setAdvanceCreditBasedOn()"
                                        required>
                                    Salary
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='advance' name="CreditBasedOn"
                                        [(ngModel)]="LeaveRuleDetail.CreditBasedOn"
                                        [ngModelOptions]="{standalone: true}" (change)="setAdvanceCreditBasedOn()"
                                        required>
                                    Advance
                                </label>

                                <div class="invalid-feedback">
                                    Please select credit basedon!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label for="AdvanceCreditBasedOn" class="form-label text-label-dark">Period </label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="AdvanceCreditBasedOn"
                                placeholder="AdvanceCreditBasedOn" title="AdvanceCreditBasedOn"
                                name="AdvanceCreditBasedOn" [(ngModel)]="LeaveRuleDetail.AdvanceCreditBasedOn"
                                #AdvanceCreditBasedOn="ngModel" required [disabled]="AdvanceCreditBasedOnDisable()"
                                (change)="setDojDocCredit()">
                                <option disabled [value]=null>--Select From--</option>
                                <option value='Monthly'>Monthly</option>
                                <option value='Yearly'>Yearly</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Effective After </label>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="2" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    placeholder="Ex. 01" id="LeaveAfterEffectiveYear" name="LeaveAfterEffectiveYear"
                                    [(ngModel)]="LeaveRuleDetail.LeaveAfterEffectiveYear"
                                    #LeaveAfterEffectiveYear="ngModel" required>
                                <span class="input-group-text" id="basic-LeaveAfterEffectiveYear">year</span>
                                <div class="invalid-feedback">
                                    Please enter effective year!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="2" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.LeaveAfterEffectiveMonth) > 11}"
                                    placeholder="Ex. 01" id="LeaveAfterEffectiveMonth" name="LeaveAfterEffectiveMonth"
                                    [(ngModel)]="LeaveRuleDetail.LeaveAfterEffectiveMonth"
                                    #LeaveAfterEffectiveMonth="ngModel" required>
                                <span class="input-group-text" id="basic-LeaveAfterEffectiveMonth">month</span>
                                <div class="invalid-feedback">
                                    Please enter effective month. maximum 11!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 px-1">
                            <input class="form-check-input" style="height: 16px; width: 16px;"
                                name="AllowLeaveRequestForConfirmedEmployee" type="checkbox" value=""
                                [(ngModel)]="LeaveRuleDetail.AllowLeaveRequestForConfirmedEmployee" />&nbsp;&nbsp;<label
                                class="form-label text-label-dark">Allow Only For Confirmed Employee
                            </label>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsClubbingRestricted" class="form-label text-label-dark">Clubbing Restricted
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="IsClubbingRestricted" [(ngModel)]="LeaveRuleDetail.IsClubbingRestricted"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="IsClubbingRestricted" [(ngModel)]="LeaveRuleDetail.IsClubbingRestricted"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="LeaveRuleClubbingRestrictionId" class="form-label text-label-dark">Restricted
                                Leave:</label>
                        </div>
                        <div class="col-md-5">
                            <ng-select [items]="LeaveTypes" [multiple]="true" bindLabel="LeaveName"
                                bindValue="LeaveMasterID" placeholder="Leave" [closeOnSelect]="false"
                                [(ngModel)]="LeaveRuleDetail.LeaveRuleClubbingRestrictionId"
                                name="LeaveRuleClubbingRestrictionId" required
                                [disabled]="!LeaveRuleDetail.IsClubbingRestricted">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                        [ngModel]="item$.selected" [ngModelOptions]="{ standalone : true }" />
                                    {{item.LeaveName}}
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value" *ngFor="let item of items.slice(0,3)">
                                        <span class="ng-value-label">{{item.LeaveName}}</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 3">
                                        <span class="ng-value-label">{{items.length - 3}} more...</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select leave!
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsSplitAllowed" class="form-label text-label-dark">Split Allowed
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="IsSplitAllowed"
                                        [(ngModel)]="LeaveRuleDetail.IsSplitAllowed"
                                        [ngModelOptions]="{standalone: true}" [disabled]="SplitDisable()">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="IsSplitAllowed"
                                        [(ngModel)]="LeaveRuleDetail.IsSplitAllowed"
                                        [ngModelOptions]="{standalone: true}" [disabled]="SplitDisable()">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsBirthdaySpecialLeaveAllowence" class="form-label text-label-dark">Birthday
                                Special Leave Allowence :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="IsBirthdaySpecialLeaveAllowence"
                                        [(ngModel)]="LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="IsBirthdaySpecialLeaveAllowence"
                                        [(ngModel)]="LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="DefaultRule" class="form-label text-label-dark">Default Policy :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                        [(ngModel)]="LeaveRuleDetail.DefaultLeave"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                        [(ngModel)]="LeaveRuleDetail.DefaultLeave"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="Description" class="form-label text-label-dark">Description :</label>
                        </div>
                        <div class="col-md-5">
                            <textarea type="text" class="form-control text-label-light" placeholder="Ex. Description"
                                id="Description" name="Description" [(ngModel)]="LeaveRuleDetail.Description"
                                #LocalAddress1="ngModel" required></textarea>
                            <div class="invalid-feedback">
                                Please enter description!
                            </div>
                        </div>
                    </div> -->

                    <div class="row mb-3">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    Date Of Confirmation
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.DateofConfirmation"></i>
                                </div>
                                <div class="card-body p-2">
                                    <div class="row">
                                        <div class="col-auto">
                                            <label class="form-check-label text-label-dark">
                                                Leave Alloted
                                            </label>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="input-group mb-3">
                                                <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(LeaveRuleDetail.DOCLeaveAlloted))"
                                                    class="form-control text-label-light"
                                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.DOCLeaveAlloted) > 365}"
                                                    placeholder="Ex. 01" id="DOCLeaveAlloted" name="DOCLeaveAlloted"
                                                    [(ngModel)]="LeaveRuleDetail.DOCLeaveAlloted"
                                                    #DOCLeaveAlloted="ngModel"
                                                    [disabled]="this.common.ToLowerCase(this.LeaveRuleDetail.DOCLeaveAllotedCredit) == 'yearly'">
                                                <!-- <span class="input-group-text" id="basic-DOCLeaveAlloted">day's per year </span> -->
                                                <div class="invalid-feedback">
                                                    Please enter accural days per year. maximum 365!
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-auto mt-1">
                                    <label class="form-label text-label-dark">Leave credit
                                    </label>
                                </div> -->
                                        <div class="col-md-auto">
                                            <select class="form-select text-label-light"
                                                aria-label="DOCLeaveAllotedCredit" placeholder="LeaveAllotedCredit"
                                                title="DOCLeaveAllotedCredit" name="DOCLeaveAllotedCredit"
                                                [(ngModel)]="LeaveRuleDetail.DOCLeaveAllotedCredit"
                                                #DOCLeaveAllotedCredit="ngModel" required disabled>
                                                <option disabled [value]=null>--Select From--</option>
                                                <option value='Monthly'>Monthly</option>
                                                <option value='Yearly'>Yearly</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    Date Of Joining
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.DateofJoining"></i>
                                </div>
                                <div class="card-body p-2">
                                    <div class="row">
                                        <div class="col-auto">
                                            <label class="form-check-label text-label-dark">
                                                Leave Alloted
                                            </label>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="input-group mb-3">
                                                <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(LeaveRuleDetail.DOJLeaveAlloted))"
                                                    class="form-control text-label-light"
                                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.DOJLeaveAlloted) > 365}"
                                                    placeholder="Ex. 01" id="DOJLeaveAlloted" name="DOJLeaveAlloted"
                                                    [(ngModel)]="LeaveRuleDetail.DOJLeaveAlloted"
                                                    #DOJLeaveAlloted="ngModel">
                                                <!-- <span class="input-group-text" id="basic-DOJLeaveAlloted">day's per year </span> -->
                                                <div class="invalid-feedback">
                                                    Please enter accural days per year. maximum 365!
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-auto mt-1">
                                    <label class="form-label text-label-dark">Leave credit
                                    </label>
                                </div> -->
                                        <div class="col-md-auto">
                                            <select class="form-select text-label-light"
                                                aria-label="DOJLeaveAllotedCredit" placeholder="LeaveAllotedCredit"
                                                title="DOJLeaveAllotedCredit" name="DOJLeaveAllotedCredit"
                                                [(ngModel)]="LeaveRuleDetail.DOJLeaveAllotedCredit"
                                                #DOJLeaveAllotedCredit="ngModel" required disabled>
                                                <option disabled [value]=null>--Select From--</option>
                                                <option value='Monthly'>Monthly</option>
                                                <option value='Yearly'>Yearly</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Effective After </label>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="2" pattern="^[0-9]\d*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    placeholder="Ex. 01" id="AfterEffectiveYear" name="AfterEffectiveYear"
                                    [(ngModel)]="LeaveRuleDetail.AfterEffectiveYear" #AfterEffectiveYear="ngModel"
                                    required>
                                <span class="input-group-text" id="basic-AfterEffectiveYear">year</span>
                                <div class="invalid-feedback">
                                    Please enter after effective year!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="2" pattern="^[0-9]\d*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.AfterEffectiveMonth) > 12}"
                                    placeholder="Ex. 01" id="AfterEffectiveMonth" name="AfterEffectiveMonth"
                                    [(ngModel)]="LeaveRuleDetail.AfterEffectiveMonth" #AfterEffectiveMonth="ngModel"
                                    required>
                                <span class="input-group-text" id="basic-AfterEffectiveMonth">month</span>
                                <div class="invalid-feedback">
                                    Please enter after effective month. maximum 12!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">from </label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="ESS_ReasonEffectiveAfterID"
                                placeholder="EffectiveFrom" title="ESS_ReasonEffectiveAfterID"
                                name="ESS_ReasonEffectiveAfterID"
                                [(ngModel)]="LeaveRuleDetail.ESS_ReasonEffectiveAfterID"
                                #ESS_ReasonEffectiveAfterID="ngModel" required>
                                <option disabled [value]=null>--Select From--</option>
                                @for (ReasonEffectiveAfter of ReasonEffectiveAfters; track
                                ReasonEffectiveAfter.ESS_ReasonEffectiveAfterID;
                                let i = $index) {
                                <option [value]=ReasonEffectiveAfter.ESS_ReasonEffectiveAfterID>
                                    {{ReasonEffectiveAfter.ReasonName}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label class="form-check-label text-label-dark" for="IsAccural">
                                Leave Alloted
                            </label>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9]\d*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.LeaveAlloted) > 365}"
                                    placeholder="Ex. 01" id="AccuralDaysPerYear" name="AccuralDaysPerYear"
                                    [(ngModel)]="LeaveRuleDetail.LeaveAlloted" #AccuralDaysPerYear="ngModel" required>
                                <span class="input-group-text" id="basic-EffectiveYear">day's per year </span>
                                <div class="invalid-feedback">
                                    Please enter accural days per year. maximum 365!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark" style="color: lightgray;">Leave credit </label>
                        </div>
                        <div class="col-md-auto">
                            <select class="form-select text-label-light" aria-label="AccuralLeaveCredit"
                                placeholder="AccuralLeaveCredit" title="AccuralLeaveCredit" name="AccuralLeaveCredit"
                                [(ngModel)]="LeaveRuleDetail.LeaveAllotedCredit" #AccuralLeaveCredit="ngModel" required
                                disabled style="color: rgb(194, 191, 191);">
                                <option disabled [value]=null>--Select From--</option>
                                <option value='Monthly'>Monthly</option>
                                <option value='Yearly'>Yearly</option>
                            </select>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-5">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="IsCarryForward">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsCarryForward"
                                            name="IsCarryForward" [(ngModel)]="LeaveRuleDetail.IsCarryForward">
                                        <label class="form-check-label text-label-dark" for="IsCarryForward">
                                            Carry Forward
                                        </label>
                                    </div>
                                </span>
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(LeaveRuleDetail.CarrryForwardLimit))"
                                    class="form-control text-label-light" placeholder="Ex. 01" id="CarrryForwardLimit"
                                    name="CarrryForwardLimit" [(ngModel)]="LeaveRuleDetail.CarrryForwardLimit"
                                    #CarrryForwardLimit="ngModel" [disabled]="!LeaveRuleDetail.IsCarryForward" required>
                                <span class="input-group-text" id="basic-limit">limit per</span>
                                <div class="invalid-feedback">
                                    Please enter carry forward limit!
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Leave credit </label>
                        </div> -->
                        <div class="col-md-auto">
                            <select class="form-select text-label-light" aria-label="CarrryForwardCredit"
                                placeholder="CarrryForwardCredit" title="CarrryForwardCredit" name="CarrryForwardCredit"
                                [(ngModel)]="LeaveRuleDetail.CarrryForwardCredit" #CarrryForwardCredit="ngModel"
                                required
                                [disabled]="!LeaveRuleDetail.IsCarryForward || this.common.ToLowerCase(LeaveRuleDetail.AdvanceCreditBasedOn) == 'yearly'">
                                <option disabled [value]=null>--Select From--</option>
                                <option value='Monthly'>Monthly</option>
                                <option value='Yearly'>Yearly</option>
                            </select>
                        </div>
                        <div class="col-md-auto">
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.LeavePolicy.CarryForward"></i>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-5">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="IsLeaveEncashment">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsLeaveEncashment"
                                            name="IsLeaveEncashment" [(ngModel)]="LeaveRuleDetail.IsLeaveEncashment">
                                        <label class="form-check-label text-label-dark" for="IsLeaveEncashment">
                                            Leave Encashment
                                        </label>
                                    </div>
                                </span>
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(LeaveRuleDetail.LeaveEncashmentLimit))"
                                    class="form-control text-label-light" placeholder="Ex. 01" id="LeaveEncashmentLimit"
                                    name="LeaveEncashmentLimit" [(ngModel)]="LeaveRuleDetail.LeaveEncashmentLimit"
                                    #LeaveEncashmentLimit="ngModel" [disabled]="!LeaveRuleDetail.IsLeaveEncashment"
                                    required>
                                <span class="input-group-text" id="basic-limit">limit per year</span>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.LeaveEncashment"></i>
                                <div class="invalid-feedback">
                                    Please enter leave encashment limit!
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-7">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="IsOptionalHolidayAllowance">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="IsOptionalHolidayAllowance"
                                            name="IsOptionalHolidayAllowance"
                                            [(ngModel)]="LeaveRuleDetail.IsOptionalHolidayAllowance">
                                        <label class="form-check-label text-label-dark"
                                            for="IsOptionalHolidayAllowance">
                                            Optional Holiday Allowance
                                        </label>
                                    </div>
                                </span>
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(LeaveRuleDetail.OptionalHolidayAllowanceLimit))"
                                    class="form-control text-label-light" placeholder="Ex. 01"
                                    id="OptionalHolidayAllowanceLimit" name="OptionalHolidayAllowanceLimit"
                                    [(ngModel)]="LeaveRuleDetail.OptionalHolidayAllowanceLimit"
                                    #OptionalHolidayAllowanceLimit="ngModel"
                                    [disabled]="!LeaveRuleDetail.IsOptionalHolidayAllowance" required>
                                <span class="input-group-text" id="basic-limit">limit per year</span>
                                <div class="invalid-feedback">
                                    Please enter optional holiday allowance!
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-8">
                            <div class="input-group mb-3">
                                <span class="input-group-text" id="Attachment">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="Attachment"
                                            name="Attachment" [(ngModel)]="LeaveRuleDetail.IsAttachment">
                                        <label class="form-check-label text-label-dark" for="Attachment">
                                            Mandatory Attachment if Leave is greater than equal to
                                        </label>
                                    </div>
                                </span>
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.AttachmentLimit) > 365}"
                                    class="form-control text-label-light" placeholder="Ex. 01"
                                    id="AttachmentAttachmentDays" name="AttachmentDays"
                                    [(ngModel)]="LeaveRuleDetail.AttachmentLimit" #AttachmentDays="ngModel"
                                    [disabled]="!LeaveRuleDetail.IsAttachment" required>
                                <span class="input-group-text" id="basic-limit">day's </span>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.MandatoryAttachmentifLeaveisgreaterthanequalto"></i>
                                <div class="invalid-feedback">
                                    Please enter attachment day's!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-1">
                <div class="card-header">
                    Restrictions
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <label class="text-label-dark mb-1">Week Off between leave period (Sandwich Rule)</label>
                        <div class="ms-2">
                            <!-- <div class="col-md-auto d-grid">
                                <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="P"
                                            name="IsWeekendBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('LeaveOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Previous day of Weekly Off
                                    </label>
                                    <i class=" bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.WeekOffbetweenleaveperiod.AbsentonPreviousdayofWeeklyOff"></i>
                                </div>
                            </div>
                            <div class="col-md-auto d-grid">
                                <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="N"
                                            name="IsWeekendBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('LeaveOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Next day of Weekly Off
                                    </label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.WeekOffbetweenleaveperiod.AbsentonNextdayofWeeklyOff"></i>
                                </div>
                            </div> -->
                            <div class="col-md-auto d-grid">
                                <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="PN"
                                            name="IsWeekendBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('LeaveOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Previous & Next day of Weekly Off
                                    </label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.WeekOffbetweenleaveperiod.AbsentonPreviousNextdayofWeeklyOff"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-auto d-grid">
                                    <!-- <div class="btn-group">
                                        <label class="form-check-label link-dark px-1 text-label-light mt-1"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value="PON"
                                                name="IsWeekendBetweenLeaveCounted"
                                                [(ngModel)]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted"
                                                [ngModelOptions]="{standalone: true}"
                                                (click)="onSelectionChange('LeaveOff',$event)"
                                                [disabled]="checkExtraleaveTypeDisableFild()">
                                            Absent on Previous or Next day of Weekly Off
                                        </label>
                                        <div>
                                            <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event)"
                                                class="form-control text-label-light"
                                                [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.WeekendBetweenLeaveCountDays) > 365}"
                                                placeholder="Ex. 01" id="WeekendBetweenLeaveCountDays"
                                                name="WeekendBetweenLeaveCountDays"
                                                [(ngModel)]="LeaveRuleDetail.WeekendBetweenLeaveCountDays"
                                                #WeekendBetweenLeaveCountDays="ngModel"
                                                [disabled]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted != 'PON'"
                                                style="width: 100px;" required>
                                            <div class="invalid-feedback">
                                                Maximum 365 days!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center ms-1">
                                            <label class="form-label text-label-light"> Days </label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.WeekOffbetweenleaveperiod.AbsentonPreviousorNextdayofWeeklyOffDays"></i>
                                        </div>
                                    </div> -->
                                    <div class="col-md-auto d-grid">
                                        <div class="btn-group">
                                            <label class="form-check-label link-dark px-1 text-label-light"
                                                ngbButtonLabel>
                                                <input class="form-check-input" type="radio" value="D"
                                                    name="IsWeekendBetweenLeaveCounted"
                                                    [(ngModel)]="LeaveRuleDetail.IsWeekendBetweenLeaveCounted"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (click)="onSelectionChange('LeaveOff',$event)"
                                                    [disabled]="checkExtraleaveTypeDisableFild()">
                                                Don’t count as leave
                                            </label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.WeekOffbetweenleaveperiod.Dontcountasleave"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="text-label-dark mb-1">Holidays between leave period (Sandwich Rule)</label>
                        <div class="ms-2">
                            <div class="col-md-auto d-grid">
                                <!-- <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="P"
                                            name="IsHolidayBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('HolidayOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Previous day of Holiday
                                    </label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Holidaysbetweenleaveperiod.AbsentonPreviousdayofHoliday"></i>
                                </div>
                                <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="N"
                                            name="IsHolidayBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('HolidayOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Next day of Holiday
                                    </label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Holidaysbetweenleaveperiod.AbsentonNextdayofHoliday"></i>
                                </div> -->
                                <div class="btn-group">
                                    <label class="form-check-label link-dark px-1 text-label-light mt-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value="PN"
                                            name="IsHolidayBetweenLeaveCounted"
                                            [(ngModel)]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted"
                                            [ngModelOptions]="{standalone: true}"
                                            (click)="onSelectionChange('HolidayOff',$event)"
                                            [disabled]="checkExtraleaveTypeDisableFild()">
                                        Absent on Previous & Next day of Holiday
                                    </label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Holidaysbetweenleaveperiod.AbsentonPreviousNextdayofHoliday"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-auto d-grid">
                                    <!-- <div class="btn-group">
                                        <label class="form-check-label link-dark px-1 text-label-light mt-1"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value="PON"
                                                name="IsHolidayBetweenLeaveCounted"
                                                [(ngModel)]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted"
                                                [ngModelOptions]="{standalone: true}"
                                                (click)="onSelectionChange('HolidayOff',$event)"
                                                [disabled]="checkExtraleaveTypeDisableFild()">
                                            Absent on Previous or Next day of Holiday
                                        </label>
                                        <div>
                                            <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event)"
                                                [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.HolidayBetweenLeaveCountDays) > 365}"
                                                class="form-control text-label-light" placeholder="Ex. 01"
                                                id="HolidayBetweenLeaveCountDays" name="HolidayBetweenLeaveCountDays"
                                                [(ngModel)]="LeaveRuleDetail.HolidayBetweenLeaveCountDays"
                                                #HolidayBetweenLeaveCountDays="ngModel"
                                                [disabled]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted != 'PON'"
                                                style="width: 100px;" required>
                                            <div class="invalid-feedback">
                                                Maximum 365 days!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center ms-1">
                                            <label class="form-label text-label-light"> Days </label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Holidaysbetweenleaveperiod.AbsentonPreviousorNextdayofHolidayDays"></i>
                                        </div>
                                    </div> -->
                                    <div class="btn-group">
                                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value="D"
                                                name="IsHolidayBetweenLeaveCounted"
                                                [(ngModel)]="LeaveRuleDetail.IsHolidayBetweenLeaveCounted"
                                                [ngModelOptions]="{standalone: true}"
                                                (click)="onSelectionChange('HolidayOff',$event)"
                                                [disabled]="checkExtraleaveTypeDisableFild()">
                                            Don’t count as leave
                                        </label>
                                        <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Holidaysbetweenleaveperiod.Dontcountasleave"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="text-label-dark mb-2">While applying leave, exceed leave balance:</label>
                        <div class="ms-2">
                            <div class="row">
                                <div class="col-md-auto">
                                    <div class="btn-group d-grid">
                                        <label class="form-check-label link-dark px-1 my-1 text-label-light"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value='Without limit'
                                                name="ExceedLeaveBalanceOption"
                                                [(ngModel)]="LeaveRuleDetail.ExceedLeaveBalanceOption"
                                                [ngModelOptions]="{standalone: true}">
                                            Without limit
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Whileapplyingleaveexceedleavebalance.Withoutlimit"></i>
                                        </label>

                                        <label class="form-check-label link-dark px-1 my-1 text-label-light"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value='Until year end limit'
                                                name="ExceedLeaveBalanceOption"
                                                [(ngModel)]="LeaveRuleDetail.ExceedLeaveBalanceOption"
                                                [ngModelOptions]="{standalone: true}">
                                            Until year end limit
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Whileapplyingleaveexceedleavebalance.Untilyearendlimit"></i>
                                        </label>

                                        <label class="form-check-label link-dark px-1 my-1 text-label-light"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio"
                                                value='Without limit and mark as LOP' name="ExceedLeaveBalanceOption"
                                                [(ngModel)]="LeaveRuleDetail.ExceedLeaveBalanceOption"
                                                [ngModelOptions]="{standalone: true}">
                                            Without limit and mark as LOP
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Whileapplyingleaveexceedleavebalance.WithoutlimitandmarkasLOP"></i>
                                        </label>

                                        <label class="form-check-label link-dark px-1 my-1 text-label-light"
                                            ngbButtonLabel>
                                            <input class="form-check-input" type="radio" value='Dont allow'
                                                name="ExceedLeaveBalanceOption"
                                                [(ngModel)]="LeaveRuleDetail.ExceedLeaveBalanceOption"
                                                [ngModelOptions]="{standalone: true}">
                                            Don’t allow
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Whileapplyingleaveexceedleavebalance.DontAllow"></i>
                                        </label>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="text-label-dark mb-1">Durations Allowed</label>
                        <div class="ms-2">
                            <div class="row">
                                <div class="col-md-auto">
                                    <div class="btn-group d-grid">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                id="IsFullDayDurationsAllowed" name="IsFullDayDurationsAllowed"
                                                [(ngModel)]="LeaveRuleDetail.IsFullDayDurationsAllowed">
                                            <label class="form-check-label text-label-light"
                                                for="IsFullDayDurationsAllowed">
                                                Full Day
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                id="IsHalfDayDurationsAllowed" name="IsHalfDayDurationsAllowed"
                                                [(ngModel)]="LeaveRuleDetail.IsHalfDayDurationsAllowed">
                                            <label class="form-check-label text-label-light"
                                                for="IsHalfDayDurationsAllowed">
                                                Half Day
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="text-label-dark">Allow requests for:</label>
                        <div class="ms-2">
                            <div class="row">
                                <div class="col-md-auto">
                                    <label class="text-label-dark">Past dates</label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.AllowrequestsforPastdates"></i>
                                </div>
                            </div>
                            <div class="row ms-5">
                                <div class="col-md-4">
                                    <div class="btn-group d-grid">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text" id="IsAllowRequestsForPastDates">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox"
                                                        id="IsAllowRequestsForPastDates"
                                                        name="IsAllowRequestsForPastDates"
                                                        [(ngModel)]="LeaveRuleDetail.IsAllowRequestsForPastDates">
                                                    <label class="form-check-label text-label-light"
                                                        for="IsAllowRequestsForPastDates">
                                                        Past
                                                    </label>
                                                </div>
                                            </span>
                                            <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event)"
                                                class="form-control text-label-light"
                                                [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.PastDateRequestLimit) > 365}"
                                                placeholder="Ex. 01" id="PastDateRequestLimit"
                                                name="PastDateRequestLimit"
                                                [(ngModel)]="LeaveRuleDetail.PastDateRequestLimit"
                                                #PastDateRequestLimit="ngModel"
                                                [disabled]="!LeaveRuleDetail.IsAllowRequestsForPastDates" required>
                                            <span class="input-group-text" id="basic-limit">days </span>
                                            <div class="invalid-feedback">
                                                Please enter days maximum 365!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ms-2">
                            <div class="row">
                                <div class="col-md-auto">
                                    <label class="text-label-dark">Future dates</label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.LeavePolicy.Restrictions.AllowrequestsforFuturedates"></i>
                                </div>
                            </div>
                            <div class="row ms-5">
                                <div class="col-md-4">
                                    <div class="btn-group d-grid">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text" id="IsAllowRequestsForFutureDates">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox"
                                                        id="IsAllowRequestsForFutureDates"
                                                        name="IsAllowRequestsForFutureDates"
                                                        [(ngModel)]="LeaveRuleDetail.IsAllowRequestsForFutureDates">
                                                    <label class="form-check-label text-label-light"
                                                        for="IsAllowRequestsForFutureDates">
                                                        Next
                                                    </label>
                                                </div>
                                            </span>
                                            <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event)"
                                                class="form-control text-label-light"
                                                [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.FutureDateRequestLimit) > 365}"
                                                placeholder="Ex. 01" id="FutureDateRequestLimit"
                                                name="FutureDateRequestLimit"
                                                [(ngModel)]="LeaveRuleDetail.FutureDateRequestLimit"
                                                #FutureDateRequestLimit="ngModel"
                                                [disabled]="!LeaveRuleDetail.IsAllowRequestsForFutureDates" required>
                                            <span class="input-group-text" id="basic-limit">days </span>
                                            <div class="invalid-feedback">
                                                Please enter days. maximum 365!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row ms-5">
                                <div class="col-md-6">
                                    <div class="input-group mb-3">
                                        <span class="input-group-text" id="IsAllowRequestsForRequestAdvance">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="IsAllowRequestsForRequestAdvance"
                                                    name="IsAllowRequestsForRequestAdvance"
                                                    [(ngModel)]="LeaveRuleDetail.IsAllowRequestsForRequestAdvance">
                                                <label class="form-check-label text-label-light"
                                                    for="IsAllowRequestsForRequestAdvance">
                                                    To be applied
                                                </label>
                                            </div>
                                        </span>
                                        <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                            (keypress)="common.NumberOnly($event)"
                                            [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.FutureDateRequestAdvance) > 365}"
                                            class="form-control text-label-light" placeholder="Ex. 01"
                                            id="FutureDateRequestAdvance" name="FutureDateRequestAdvance"
                                            [(ngModel)]="LeaveRuleDetail.FutureDateRequestAdvance"
                                            #FutureDateRequestAdvance="ngModel"
                                            [disabled]="!LeaveRuleDetail.IsAllowRequestsForRequestAdvance || LeaveRuleDetail.AllowLeaveForPreviousMonth"
                                            required>
                                        <span class="input-group-text" id="basic-limit">days in advance</span>
                                        <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Tobeapplieddaysinadvance"></i>
                                        <div class="invalid-feedback">
                                            Please enter days in advance. maximum 365!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsAdminsOnEmployeeBehalf"
                                    name="IsAdminsOnEmployeeBehalf"
                                    [(ngModel)]="LeaveRuleDetail.IsAdminsOnEmployeeBehalf">
                                <label class="form-check-label text-label-dark" for="IsAdminsOnEmployeeBehalf">
                                    Allow only admins to view and apply this leave on employee’s behalf
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsMinimumLeavePerApplication"
                                    name="IsMinimumLeavePerApplication"
                                    [(ngModel)]="LeaveRuleDetail.IsMinimumLeavePerApplication">
                                <label class="form-check-label  text-label-dark" for="IsMinimumLeavePerApplication">
                                    Minimum leave that can be availed per application
                                </label>
                                <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                    [ngbTooltip]="tooltip.LeavePolicy.Restrictions.Minimumleavethatcanbeavailedperapplication"></i>
                            </div>
                        </div>
                        <div class="col-md-2" style="width: 160px;">
                            <div class="mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    placeholder="Ex. 01" id="MinimumLeavePerApplication"
                                    name="MinimumLeavePerApplication"
                                    [(ngModel)]="LeaveRuleDetail.MinimumLeavePerApplication"
                                    #MinimumLeavePerApplication="ngModel" required
                                    [disabled]="!LeaveRuleDetail.IsMinimumLeavePerApplication">
                                <div class="invalid-feedback">
                                    Please enter count!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsMaximumConsecutiveDaysAllowed"
                                    name="IsMaximumConsecutiveDaysAllowed"
                                    [(ngModel)]="LeaveRuleDetail.IsMaximumConsecutiveDaysAllowed">
                                <label class="form-check-label  text-label-dark" for="IsMaximumConsecutiveDaysAllowed">
                                    Maximum number of consecutive days of leave allowed
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2" style="width: 160px;">
                            <div class="mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    placeholder="Ex. 01" id="MaximumConsecutiveDaysAllowed"
                                    name="MaximumConsecutiveDaysAllowed"
                                    [(ngModel)]="LeaveRuleDetail.MaximumConsecutiveDaysAllowed"
                                    #MaximumConsecutiveDaysAllowed="ngModel" required
                                    [disabled]="!LeaveRuleDetail.IsMaximumConsecutiveDaysAllowed">
                                <div class="invalid-feedback">
                                    Please enter day's!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsMinimumGapBetweenApplications"
                                    name="IsMinimumGapBetweenApplications"
                                    [(ngModel)]="LeaveRuleDetail.IsMinimumGapBetweenApplications">
                                <label class="form-check-label  text-label-dark" for="IsMinimumGapBetweenApplications">
                                    Minimum gap (in days) between two applications
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2" style="width: 160px;">
                            <div class="mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.MinimumGapBetweenApplications) > 365}"
                                    class="form-control text-label-light" placeholder="Ex. 01"
                                    id="MinimumGapBetweenApplications" name="MinimumGapBetweenApplications"
                                    [(ngModel)]="LeaveRuleDetail.MinimumGapBetweenApplications"
                                    #MinimumGapBetweenApplications="ngModel" required
                                    [disabled]="!LeaveRuleDetail.IsMinimumGapBetweenApplications">
                                <div class="invalid-feedback">
                                    Please enter day's!
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsFileUploadRequired"
                                    name="IsFileUploadRequired" [(ngModel)]="LeaveRuleDetail.IsFileUploadRequired">
                                <label class="form-check-label  text-label-dark" for="IsFileUploadRequired">
                                    Enable file upload option if the applied leave period exceeds
                                </label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9]\d*$"
                                    (keypress)="common.NumberOnly($event)"
                                    [ngClass]="{'ng-invalid': common.parseFloat(LeaveRuleDetail.FileUploadLImit) > 365}"
                                    class="form-control text-label-light" placeholder="Ex. 01" id="FileUploadLImit"
                                    name="FileUploadLImit" [(ngModel)]="LeaveRuleDetail.FileUploadLImit"
                                    #FileUploadLImit="ngModel" required
                                    [disabled]="!LeaveRuleDetail.IsFileUploadRequired"
                                    oninput="this.value = Math.floor(Math.abs(this.value))">
                                <span class="input-group-text" id="basic-FileUploadLImit">days</span>
                                <div class="invalid-feedback">
                                    Please enter days. maximum 365!
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="IsMaximumApplicationsPerYear"
                                    name="IsMaximumApplicationsPerYear"
                                    [(ngModel)]="LeaveRuleDetail.IsMaximumApplicationsPerYear">
                                <label class="form-check-label  text-label-dark" for="IsMaximumApplicationsPerYear">
                                    Maximum number of applications allowed within the year
                                </label>
                            </div>
                        </div>
                        <div class="col-md-2" style="width: 160px;">
                            <div class="mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control  text-label-light"
                                    placeholder="Ex. 01" id="MaximumApplicationsPerYear"
                                    name="MaximumApplicationsPerYear"
                                    [(ngModel)]="LeaveRuleDetail.MaximumApplicationsPerYear"
                                    #MaximumApplicationsPerYear="ngModel" required
                                    [disabled]="!LeaveRuleDetail.IsMaximumApplicationsPerYear">
                                <div class="invalid-feedback">
                                    Please enter days!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="LeaveRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && LeaveRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.LeaveRuleDetail.ESS_LeaveRuleID == 0) || (this.common.PageRight.IsEdit && this.LeaveRuleDetail.ESS_LeaveRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>